var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardCashback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 4,
    fill: "#FF8400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7516 25.8604V27.8904C19.7516 29.6104 18.1516 31.0004 16.1816 31.0004C14.2116 31.0004 12.6016 29.6104 12.6016 27.8904V25.8604C12.6016 27.5804 14.2016 28.8004 16.1816 28.8004C18.1516 28.8004 19.7516 27.5704 19.7516 25.8604Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7501 23.1097C19.7501 23.6097 19.6101 24.0697 19.3701 24.4697C18.7801 25.4397 17.57 26.0497 16.17 26.0497C14.77 26.0497 13.56 25.4297 12.97 24.4697C12.73 24.0697 12.5901 23.6097 12.5901 23.1097C12.5901 22.2497 12.9901 21.4797 13.6301 20.9197C14.2801 20.3497 15.17 20.0098 16.16 20.0098C17.15 20.0098 18.0401 20.3597 18.6901 20.9197C19.3501 21.4697 19.7501 22.2497 19.7501 23.1097Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7516 23.11V25.86C19.7516 27.58 18.1516 28.8 16.1816 28.8C14.2116 28.8 12.6016 27.57 12.6016 25.86V23.11C12.6016 21.39 14.2016 20 16.1816 20C17.1716 20 18.0616 20.35 18.7116 20.91C19.3516 21.47 19.7516 22.25 19.7516 23.11Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19.9702V22.0302C31 22.5802 30.56 23.0302 30 23.0502H28.0399C26.9599 23.0502 25.97 22.2602 25.88 21.1802C25.82 20.5502 26.0599 19.9602 26.4799 19.5502C26.8499 19.1702 27.36 18.9502 27.92 18.9502H30C30.56 18.9702 31 19.4202 31 19.9702Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.5V17.5C11 14.78 12.64 12.88 15.19 12.56C15.45 12.52 15.72 12.5 16 12.5H25C25.26 12.5 25.51 12.51 25.75 12.55C28.33 12.85 30 14.76 30 17.5V18.95H27.92C27.36 18.95 26.85 19.17 26.48 19.55C26.06 19.96 25.82 20.55 25.88 21.18C25.97 22.26 26.96 23.05 28.04 23.05H30V24.5C30 27.5 28 29.5 25 29.5H22.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCashback);
export default __webpack_public_path__ + "static/media/dashboard-cashback.7394cd075967b8e0a21415a691d32897.svg";
export { ForwardRef as ReactComponent };